import { render, staticRenderFns } from "./FamilyWholesaleDiscountsShowEdit.vue?vue&type=template&id=05e4f7f6&lang=pug&"
import script from "./FamilyWholesaleDiscountsShowEdit.vue?vue&type=script&lang=js&"
export * from "./FamilyWholesaleDiscountsShowEdit.vue?vue&type=script&lang=js&"
import style0 from "./FamilyWholesaleDiscountsShowEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FamilyWholesaleDiscountsShowEdit.vue"
export default component.exports